module.exports = __webpack_public_path__ + "img/nongzilvzhi.02348947.png";